import script from "./BoundleList.vue?vue&type=script&setup=true&lang=js"
export * from "./BoundleList.vue?vue&type=script&setup=true&lang=js"

import "./BoundleList.vue?vue&type=style&index=0&id=24f1abbc&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f1abbc"]])

export default __exports__